module.exports = __webpack_public_path__ + "img/location_pin.217d455b.png";